import { ImageFill } from 'react-bootstrap-icons';
import styled from "@emotion/styled";
import backgroundImage from "../temp-background.png"
import { useLocation } from 'react-router-dom';

const StyledNav = styled("nav")({
  position: "relative",
  isolation: "isolate",
  paddingBottom: "7rem",
  "&::before": {
    content: '""',
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    backgroundImage: `url(${backgroundImage})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    opacity: 0.33,
    zIndex: -1,
  }
})

export const NavBar = () => {
    const location = useLocation();
    
    const getPageTitle = (pathname: string) => {
        if (pathname === '/') return 'Home';
        const title = pathname.substring(1);
        return title.charAt(0).toUpperCase() + title.slice(1);
    }

    return (
        <StyledNav className="navbar navbar-expand-lg" data-bs-theme="dark">
            <div className="container-fluid">
                <a className="navbar-brand" href="/"><ImageFill color='white' size='32'/></a>
                <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
                <span className="navbar-toggler-icon"></span>
                </button>
                <div className="collapse navbar-collapse justify-content-center" id="navbarNav">
                    <div className="d-flex flex-column align-items-center">
                        <ul className="navbar-nav">
                            <li className="nav-item">
                            <a className="nav-link" href="/About">ABOUT</a>
                            </li>
                            <li className="nav-item">
                            <a className="nav-link" href="/Services">SERVICES</a>
                            </li>
                            <li className="nav-item">
                            <a className="nav-link" href="/Contact">CONTACT</a>
                            </li>
                        </ul>
                        <h3 style={{marginTop: "1rem"}} className="display-6 fw-bold lh-1 text-body-emphasis mb-3 py-2">{getPageTitle(location.pathname).toUpperCase()}</h3>
                    </div>
                </div>
            </div>
        </StyledNav>
    )
}